module.exports = __webpack_public_path__ + "8b758365b04b01b5b03b49f3fb99902f.svg";